import classes from "./FooterInfo.module.css";
import { MENU_HEADER, NAIL_SHOP_INFO, SOLCO_INFO } from "../../utils/Const";
import { images } from "../../assets/img";
import useCheckIsMobile from "../../hook/useCheckIsMobile";

const FooterInfo = (props) => {
  const { style } = props;
  const isMobile = useCheckIsMobile();
  const currentYear = new Date().getFullYear();

  return (
    <div className={classes.wrapper}>
      <img
        className={`${classes.shopLogo}`}
        alt={"main logo"}
        src={images.shop_logo}
      />

      <div className={`${classes.container} ${style}`}>
        <div className={classes.columnInfo}>
          <div className={classes.address}>
            <h2>{NAIL_SHOP_INFO.name}</h2>
            <a
              target={"_blank"}
              href={NAIL_SHOP_INFO.ggMapUrl}
              rel="noreferrer"
            >
              {`${NAIL_SHOP_INFO.address}${isMobile ? "" : "\n"}\n\n`}
            </a>
          </div>

          <div className={classes.openingTimeWrapper}>
            <h3>Opening Time</h3>
            <div className={classes.openingTimeContainer}>
              <div className={classes.openingTime}>
                <h3>{`${NAIL_SHOP_INFO.openingTime.openTime.weekdays}`}</h3>
                <h3>{`${NAIL_SHOP_INFO.openingTime.openTime.time}`}</h3>
              </div>
              <div className={classes.openingTime}>
                <h3>{`${NAIL_SHOP_INFO.openingTime.closeTime.weekdays}`}</h3>
                <h3>{`${NAIL_SHOP_INFO.openingTime.closeTime.time}`}</h3>
              </div>
              <div className={classes.openingTime}>
                <h3>{`Sun`}</h3>
                <h3>{`10AM - 5PM`}</h3>
              </div>
            </div>
          </div>
        </div>

        <div className={classes.contactContainer}>
          <h3>Contact Us</h3>
          <a
            href={`tel:${NAIL_SHOP_INFO.tel}`}
          >{`Hotline: ${NAIL_SHOP_INFO.phone}\n\n`}</a>
          <a
            href={`mailto:${NAIL_SHOP_INFO.email}`}
          >{`Email: ${NAIL_SHOP_INFO.email}`}</a>
        </div>

        <div className={classes.columnInfo}>
          <div
            className={`${classes.contactContainer} ${classes.marginBottom}`}
          >
            <h3>Follow Us</h3>
            <a
              target={"_blank"}
              href={NAIL_SHOP_INFO.instagram}
              rel="noreferrer"
            >
              <img alt={"insta"} src={images.instaIcon} />
            </a>
            <a
              target={"_blank"}
              href={NAIL_SHOP_INFO.facebook}
              rel="noreferrer"
            >
              <img alt={"insta"} src={images.fbIcon} />
            </a>
          </div>

          <br />

          <div
            className="fb-page"
            data-href={NAIL_SHOP_INFO.facebook}
            data-tabs="timeline"
            data-width={isMobile ? "320" : "300"}
            data-height="100"
            data-small-header="false"
            data-adapt-container-width="false"
            data-hide-cover="false"
            data-show-facepile="true"
          >
            <blockquote
              cite={NAIL_SHOP_INFO.facebook}
              className="fb-xfbml-parse-ignore"
            >
              <a href={NAIL_SHOP_INFO.facebook}>{NAIL_SHOP_INFO.name}</a>
            </blockquote>
          </div>
        </div>

        <div className={classes.menuContainer}>
          {MENU_HEADER.map((item) => (
            <a className={classes.menuLink} href={item?.navigationKey}>
              {item.name}
            </a>
          ))}
        </div>

      </div>
      
      <div className={classes.creditFooter}>
        <h4>
          {`Copyright \u00A9 ${currentYear} ${NAIL_SHOP_INFO.name}. All rights reserved. Designed by `}
          <a target={"_blank"} href={SOLCO_INFO.website} rel="noreferrer">
            {`SOLCO Marketing`}
          </a>
          {` & `}
          <a target={"_blank"} href={SOLCO_INFO.huaCatLuongWebsite} rel="noreferrer">
            {`Hua Cat Luong`}
          </a>
        </h4>
      </div>
    </div>
  );
};

export default FooterInfo;
